import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { UserStatus } from '@app/shared/types/enums/user-status.enum';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-user-status',
  imports: [MatIconModule, TranslatePipe],
  templateUrl: './user-status.component.html'
})
export class UserStatusComponent {
  public readonly userStatus = input<UserStatus>(undefined);
}
